module.exports = __webpack_public_path__ + "static/media/linkedin.4110be4f.svg";